/* 
Object:         Occupancy (bezetting)
Description:    Logic and events for the module Occupancy (Bezetting)
Used in:        Occupancy
*/

import * as appsettings     from "../appsettings";
import * as communication   from "../communication";
import * as main            from "../main";


type DayData = {
    [key: string]: number;
}

type AvailablePeople = {
    [serviceFunctionId: number]: DayData;
}

type OccupancyHours = {
    [serviceFunctionId: number]: DayData;
}

let occupancyHours: OccupancyHours = {};
let availablePeople: AvailablePeople = {};

/**
* Refresh vehicles from group
* @param {number} groupId
*/
function loadVehicles(groupId: number): void {
    if (groupId != undefined) {

        const data = { groupId: groupId };
        communication.syncJSON("GET", appsettings.getUrl("Occupancy/GetVehicles"), data, function (responseData) {
            // Listbox
            const lb = $("#LVehicles").data("kendoListBox");
            lb.dataSource.data(responseData);
        });
    }
}

/**
* Refresh no occupancy summary with new data
* @param {string} newData
*/
function refreshNoOccupancySummary(newData: string): void {
    if (newData != null) {
        // Listbox            
        var lb = $("#LBNoOccupancyDays").data("kendoListBox");
        lb.dataSource.data(newData);
    }
}

/**
* Refresh total occupancy
* @param {TotalOccupancy[] | null} jsonData
*/
function refreshTotalsOccupancy(jsonData: TotalOccupancy[] | null): void {

    //Table or List?
    var htmlData = "<table style='width: 100%'>";

    if (jsonData === null) return;

    for (let i = 0; i < jsonData.length; i++) {
        let totalOccupancy = jsonData[i];

        // int OrderBy
        // int ServiceFunctionID
        // string Label
        // int Available { get; set; }
        // int Necessary { get; set; }
        // int Configured { get; set; }
        // bool Occupancy { get; set; }

        let { OrderBy, ServiceFunctionID, Label, Available, Necessary, Configured, Occupancy } = jsonData[i];
        htmlData += "<tr>";
        htmlData += "<td><span>" + Label + "</span></td>";
        htmlData += "<td class='countertableHeader' data-id='" + ServiceFunctionID + "'>";
        if (Occupancy) {
            htmlData += "<span class='countertableHeader-red'>";
        }
        else {
            htmlData += "<span class='countertableHeader'>";
        }

        htmlData += Available + "/" + Necessary + "/" + Configured + "</span></td>";
        htmlData += "</tr>";
    }

    htmlData += "</table>";

    $("#TTotals").html(htmlData);
}

/**
* refresh detail occupancy
* @param {string} htmlData
*/
function refreshDetailsOccupancy(htmlData: string): void {
    //Panel
    $('#POccupancy').html(htmlData);
}

/**
 * Refresh available people data.
 * @param jsonData Array of service function entries
 */
function refreshAvailablePeople(jsonData: ServiceFunctionDayAvailable[]): void {

    // Reset the dictionary properly
    availablePeople = {};

    if (!Array.isArray(jsonData)) return;

    for (const item of jsonData) {
        const { ServiceFunctionID, DateOfDay, DayCounters } = item;

        if (!ServiceFunctionID || !DateOfDay || !Array.isArray(DayCounters))
            continue;

        const dayData = availablePeople[ServiceFunctionID] ?? {};

        for (const { K, V } of DayCounters) {
            dayData[`Q${DateOfDay}${K}`] = V;
        }

        availablePeople[ServiceFunctionID] = dayData;
    }
}

/**
* refresh occupancy hours
* @param {string} jsonData
*/
function refreshOccupancyHours(jsonData: ServiceFunctionDayOccupied[]) {

    //Array
    occupancyHours = {};

    if (jsonData === null) return;

    for (let s = 0; s < jsonData.length; s++) {
        //let serviceFunctionDataItem = jsonData[i];

        // ServiceFunctionDataItem
        // int ServiceFunctionID
        // string CounterData                

        let { ServiceFunctionID, DateOfDay, DayCounters } = jsonData[s];

        var dayData = occupancyHours[ServiceFunctionID];
        if (dayData == null) {
            dayData = {};
        }
        for (let q = 0; q < DayCounters.length; q++) {
            let { K, V } = DayCounters[q];

            dayData['Q' + DateOfDay + K] = V ? 1 : 0;           // dayData['Q' + DateOfDay + K] = V;  => Original code (any), but changed to 1/0 because V is boolean, and DayData is expected to be number
        }
        occupancyHours[ServiceFunctionID] = dayData;
    }
}


/**
* AddHoverCurrentHour
*/
function addHoverFunctions() {

    //LSFunctionID = e.getAttribute('data-storage-id');
    //$(this).closest('div').attr('data-storage-id')

    $('.stripes li:nth-child(1)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 0, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 0, 0); });
    $('.stripes li:nth-child(2)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 0, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 0, 15); });
    $('.stripes li:nth-child(3)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 0, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 0, 30); });
    $('.stripes li:nth-child(4)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 0, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 0, 45); });
    $('.stripes li:nth-child(5)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 1, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 1, 0); });
    $('.stripes li:nth-child(6)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 1, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 1, 15); });
    $('.stripes li:nth-child(7)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 1, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 1, 30); });
    $('.stripes li:nth-child(8)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 1, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 1, 45); });
    $('.stripes li:nth-child(9)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 2, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 2, 0); });
    $('.stripes li:nth-child(10)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 2, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 2, 15); });
    $('.stripes li:nth-child(11)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 2, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 2, 30); });
    $('.stripes li:nth-child(12)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 2, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 2, 45); });
    $('.stripes li:nth-child(13)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 3, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 3, 0); });
    $('.stripes li:nth-child(14)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 3, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 3, 15); });
    $('.stripes li:nth-child(15)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 3, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 3, 30); });
    $('.stripes li:nth-child(16)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 3, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 3, 45); });
    $('.stripes li:nth-child(17)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 4, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 4, 0); });
    $('.stripes li:nth-child(18)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 4, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 4, 15); });
    $('.stripes li:nth-child(19)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 4, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 4, 30); });
    $('.stripes li:nth-child(20)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 4, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 4, 45); });
    $('.stripes li:nth-child(21)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 5, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 5, 0); });
    $('.stripes li:nth-child(22)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 5, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 5, 15); });
    $('.stripes li:nth-child(23)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 5, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 5, 30); });
    $('.stripes li:nth-child(24)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 5, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 5, 45); });
    $('.stripes li:nth-child(25)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 6, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 6, 0); });
    $('.stripes li:nth-child(26)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 6, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 6, 15); });
    $('.stripes li:nth-child(27)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 6, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 6, 30); });
    $('.stripes li:nth-child(28)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 6, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 6, 45); });
    $('.stripes li:nth-child(29)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 7, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 7, 0); });
    $('.stripes li:nth-child(30)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 7, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 7, 15); });
    $('.stripes li:nth-child(31)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 7, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 7, 30); });
    $('.stripes li:nth-child(32)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 7, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 7, 45); });
    $('.stripes li:nth-child(33)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 8, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 8, 0); });
    $('.stripes li:nth-child(34)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 8, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 8, 15); });
    $('.stripes li:nth-child(35)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 8, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 8, 30); });
    $('.stripes li:nth-child(36)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 8, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 8, 45); });
    $('.stripes li:nth-child(37)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 9, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 9, 0); });
    $('.stripes li:nth-child(38)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 9, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 9, 15); });
    $('.stripes li:nth-child(39)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 9, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 9, 30); });
    $('.stripes li:nth-child(40)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 9, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 9, 45); });
    $('.stripes li:nth-child(41)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 10, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 10, 0); });
    $('.stripes li:nth-child(42)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 10, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 10, 15); });
    $('.stripes li:nth-child(43)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 10, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 10, 30); });
    $('.stripes li:nth-child(44)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 10, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 10, 45); });
    $('.stripes li:nth-child(45)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 11, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 11, 0); });
    $('.stripes li:nth-child(46)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 11, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 11, 15); });
    $('.stripes li:nth-child(47)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 11, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 11, 30); });
    $('.stripes li:nth-child(48)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 11, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 11, 45); });
    $('.stripes li:nth-child(49)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 12, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 12, 0); });
    $('.stripes li:nth-child(50)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 12, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 12, 15); });
    $('.stripes li:nth-child(51)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 12, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 12, 30); });
    $('.stripes li:nth-child(52)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 12, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 12, 45); });
    $('.stripes li:nth-child(53)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 13, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 13, 0); });
    $('.stripes li:nth-child(54)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 13, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 13, 15); });
    $('.stripes li:nth-child(55)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 13, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 13, 30); });
    $('.stripes li:nth-child(56)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 13, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 13, 45); });
    $('.stripes li:nth-child(57)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 14, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 14, 0); });
    $('.stripes li:nth-child(58)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 14, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 14, 15); });
    $('.stripes li:nth-child(59)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 14, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 14, 30); });
    $('.stripes li:nth-child(60)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 14, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 14, 45); });
    $('.stripes li:nth-child(61)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 15, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 15, 0); });
    $('.stripes li:nth-child(62)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 15, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 15, 15); });
    $('.stripes li:nth-child(63)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 15, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 15, 30); });
    $('.stripes li:nth-child(64)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 15, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 15, 45); });
    $('.stripes li:nth-child(65)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 16, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 16, 0); });
    $('.stripes li:nth-child(66)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 16, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 16, 15); });
    $('.stripes li:nth-child(67)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 16, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 16, 30); });
    $('.stripes li:nth-child(68)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 16, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 16, 45); });
    $('.stripes li:nth-child(69)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 17, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 17, 0); });
    $('.stripes li:nth-child(70)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 17, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 17, 15); });
    $('.stripes li:nth-child(71)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 17, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 17, 30); });
    $('.stripes li:nth-child(72)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 17, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 17, 45); });
    $('.stripes li:nth-child(73)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 18, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 18, 0); });
    $('.stripes li:nth-child(74)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 18, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 18, 15); });
    $('.stripes li:nth-child(75)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 18, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 18, 30); });
    $('.stripes li:nth-child(76)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 18, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 18, 45); });
    $('.stripes li:nth-child(77)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 19, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 19, 0); });
    $('.stripes li:nth-child(78)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 19, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 19, 15); });
    $('.stripes li:nth-child(79)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 19, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 19, 30); });
    $('.stripes li:nth-child(80)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 19, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 19, 45); });
    $('.stripes li:nth-child(81)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 20, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 20, 0); });
    $('.stripes li:nth-child(82)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 20, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 20, 15); });
    $('.stripes li:nth-child(83)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 20, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 20, 30) });
    $('.stripes li:nth-child(84)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 20, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 20, 45); });
    $('.stripes li:nth-child(85)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 21, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 21, 0); });
    $('.stripes li:nth-child(86)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 21, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 21, 15); });
    $('.stripes li:nth-child(87)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 21, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 21, 30); });
    $('.stripes li:nth-child(88)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 21, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 21, 45); });
    $('.stripes li:nth-child(89)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 22, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 22, 0); });
    $('.stripes li:nth-child(90)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 22, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 22, 15); });
    $('.stripes li:nth-child(91)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 22, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 22, 30); });
    $('.stripes li:nth-child(92)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 22, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 22, 45); });
    $('.stripes li:nth-child(93)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 23, 0); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 23, 0); });
    $('.stripes li:nth-child(94)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 23, 15); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 23, 15); });
    $('.stripes li:nth-child(95)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 23, 30); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 23, 30); });
    $('.stripes li:nth-child(96)')
        .on('mouseenter', function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 23, 45); })
        .on('mouseleave', function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 23, 45); });
}

function getDateString(date: Date): string {
    // yyyy-MM-dd
    var dateStr =
        date.getFullYear() + "-" +
        ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
        ("00" + date.getDate()).slice(-2);
    return dateStr;
}

/**
* refresh occupancy hours
* @param {number} groupId
* @param {Date[]} selectedDates
*/
function refreshOccup(groupId: number, selectedDates: Date[]) {
    if (selectedDates.length > 0) {

        let dateObjectSelectedDate = [];
        for (let i = 0; i < selectedDates.length; i++) {
            dateObjectSelectedDate.push(getDateString(new Date(selectedDates[i])));
        }

        const actionUrl = "Occupancy/GetOccupancy";
        $.ajax({
            type: "POST",
            // async: false, // May be necessary when EF error for already used context
            url: appsettings.getUrl(actionUrl),
            data: { groupId: groupId, selectedDates: dateObjectSelectedDate },
            success: function (data) {
                refreshNoOccupancySummary(data.NoOccupancySummary);
                refreshTotalsOccupancy(data.TotalsOccupancy);
                refreshDetailsOccupancy(data.DetailsOccupancy);
                refreshAvailablePeople(data.AvailablePeople);
                refreshOccupancyHours(data.OccupancyHours);

                addHoverFunctions();

                const date0 = selectedDates[0];

                let year = ('' + date0.getFullYear()).slice(2);
                let month = ('0' + (date0.getMonth() + 1)).slice(-2);
                let day = ('0' + date0.getDate()).slice(-2);

                const d = new Date();
                let hour = d.getHours();
                let minute = Number((d.getMinutes() - (d.getMinutes() % 15)).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }));

                const date = year + month + day;
                hoverCurrentHour(date, hour, minute);
            }
        });
    }
}

/**
* Hover event current hour
* @param {string} day
* @param {number} hour
* @param {number} minute
*/
function hoverCurrentHour(day: string, hour: number, minute: number): void {

    const key = 'Q' + day + hour + zeroPad(minute, 2);
    const value = (id: number) => availablePeople[id]?.[key];

    $('.available-people').each(function () {

        const el = this as HTMLElement;
        const id = Number(el.getAttribute('data-id'));

        const textContent = value(id);
        if (textContent == null) return;

        // HEADER COUNTER
        const headerCounter = document.querySelector<HTMLElement>(
            `.countertableHeader[data-id="${id}"], .countertableHeader-red[data-id="${id}"]`
        );

        if (!headerCounter) return;

        const currentHeaderParts = headerCounter.textContent?.split('/') ?? [];
        headerCounter.textContent =
            String(textContent) + (currentHeaderParts.length > 1 ? '/' + currentHeaderParts.slice(1).join('/') : '');

        // AVAILABLE COUNTERS
        const counters = document.querySelectorAll<HTMLElement>(
            `.available-people[data-id="${id}"]`
        );

        counters.forEach(counter => {
            const parts = counter.textContent?.split('/') ?? [];
            if (parts.length === 2) {
                counter.textContent = String(textContent) + '/' + parts[1];
            }
        });

        // CLASS LOGIC (clean toggle instead of add/remove)
        const parent = el.parentElement;
        if (!parent) return;

        const isOccupied = !!occupancyHours?.[id]?.[key];               // '!!' = convert to boolean

        parent.classList.toggle('counter-red', isOccupied);
        parent.classList.toggle('counter', !isOccupied);

        headerCounter.classList.toggle('countertableHeader-red', isOccupied);
        headerCounter.classList.toggle('countertableHeader', !isOccupied);
    });

    // STRIPES highlight (gefixte string interpolation)
    const index = 1 + (hour * 4) + (minute / 15);

    $(`[data-storage-id="${day}"] .stripes li:nth-child(${index})`)
        .css('background', 'rgba(200, 225, 239, 0.8)');
}

/**
* UnhoverCurrentHour
* @param {number} hour
* @param {number} minute
*/
function unhoverCurrentHour(day: string, hour: number, minute: number): void {
    $('[data-storage-id=' + day + '] .stripes li:nth-child(' + (1 + (hour * 4) + (minute / 15)) + ')').css('background', 'rgba(225, 228, 232, 0.4)');//'#e1e4e8' light grey

    $('[data-storage-id=' + day + '] .available-people').each(function () {
        const id = Number(this.getAttribute('data-id'));

        if (occupancyHours[id]['Q' + day + hour + zeroPad(minute, 2)]) {
            $('[data-storage-id=' + day + '] #staffing-grid' + id + ' .stripes li:nth-child(' + (1 + (hour * 4) + (minute / 15)) + ')').css('background', 'rgba(232, 212, 213, 0.4)');//'#e8d4d5' light pink
        }
    });
}


/**
* Check if the DOM element object has a certain class object
* @param {Object} num
* @param {Object} places
*/
function zeroPad(num: number, places: number): string {
    const zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join('0') + num;
}


/**
 * Check if the DOM element object has a certain class object
 * @param obj
 * @param cname
 */
function hasClass(obj: Element, cname: string): boolean {
    return obj.classList.contains(cname);
}

/**
 * Add a certain class from a DOM element/
 * @param obj
 * @param cname
 */
function addClass(obj: Element, cname: string): void {
    obj.classList.add(cname);
}

/**
 * Remove a certain class from a DOM element
 * @param obj
 * @param cname
 */
function removeClass(obj: Element, cname: string): void {
    obj.classList.remove(cname);
}


/**
* Init (binding button actions)
*/
export function initialize(): void {
    this.occupancyHours = {};
    this.availablePeople = {};

    const calendarSelectedDate = $("#CSelectedDate").data("kendoCalendar");
    const selectedDates = calendarSelectedDate.selectDates();

    const ddlGroup = $("#DDLGroup");
    const groupId = Number(ddlGroup.val());

    if (selectedDates != null && groupId != null) {
        loadVehicles(groupId);
        refreshOccup(groupId, selectedDates);
    }
}

/**
* Toggle Function
* @param {HTMLElement} e
*/
export function toggleFunction(e: HTMLElement): void {

    const functionId = e.parentElement?.getAttribute('data-function-id');
    if (!functionId) return;

    const elements = document.querySelectorAll<HTMLElement>(
        `[data-function-id="${functionId}"]`
    );

    elements.forEach(el => {
        el.classList.toggle('collapsed');
    });
}


/**
* Load summary occupancy for the current selected group and date
* @param {number} groupId
* @param {string} selectedDate
*/
export function loadNoOccupancySummary(groupId: number, selectedDate: string): void {
    const data = { groupId: groupId, selectedDate: selectedDate };
    communication.syncJSON("GET", appsettings.getUrl("Occupancy/GetNoOccupancySummary"), data, function (responseData) {
        refreshNoOccupancySummary(responseData);
    });
}


/**
* Load the totals of occupancy
* @param {number} groupId
* @param {string} selectedDate
*/
export function loadTotalsOccupancy(groupId: number, selectedDate: string): void {
    const data = { groupId: groupId, selectedDate: selectedDate };
    communication.syncJSON("GET", appsettings.getUrl("Occupancy/GetTotalsOccupancy"), data, function (responseData) {
        refreshTotalsOccupancy(responseData);
    });
}


/**
* Load detail occupancy
* @param {number} groupId
* @param {string} selectedDate
*/
export function loadDetailsOccupancy(groupId: number, selectedDate: string): void {
    const data = { groupId: groupId, selectedDate: selectedDate };
    communication.syncJSON("GET", appsettings.getUrl("Occupancy/GetDetailsOccupancy"), data, function (responseData) {
        refreshDetailsOccupancy(responseData);
    });
}


/**
* Date changed, refresh occupancy overview
*/
export function onChangeCSelectedDate(): void {
    const ddlGroup = $("#DDLGroup");
    const groupId = Number(ddlGroup.val());
    if (groupId != undefined && groupId != null) {
        refreshOccup(groupId, this.selectDates());
    }
}

export function onClickDatePeriod(days: number): void {
    const ddlGroup = $("#DDLGroup");
    const groupId = Number(ddlGroup.val());
    if (groupId != undefined && groupId != null) {
        const datePeriod: Date[] = [];

        const date = new Date().setHours(0, 0, 0, 0);
        const today = new Date(date);

        for (let i = 0; i < days; i++) {
            const dateTemp = new Date().setHours(0, 0, 0, 0);
            const todayTemp = new Date(dateTemp);
            datePeriod.push(new Date(todayTemp.setDate(today.getDate() + i)));
        }

        const calendarSelectedDate = $("#CSelectedDate").data("kendoCalendar");
        calendarSelectedDate.selectDates(datePeriod);

        refreshOccup(groupId, datePeriod);
    }
}

export function addDays(date: Date, number: number): Date {
    const newDate = new Date(date);
    return new Date(newDate.setDate(date.getDate() + number));
}

/**
* Group changed, refresh vehicles and occupancy overview
*/
export function onChangeDDLGroup(): void {
    loadVehicles(this.value());

    const calendarSelectedDate = $("#CSelectedDate").data("kendoCalendar");
    const selectedDates = calendarSelectedDate.selectDates();
    if (selectedDates != null) {
        refreshOccup(this.value(), selectedDates);
    }
}

/**
* No Occupancy day clicked, refresh occupancy overview
* @param {kendo.ui.ListBoxEvent} e
*/
export function onClickLBNoOccupancyDay(e: kendo.ui.ListBoxEvent): void {
    const ddlGroup = $("#DDLGroup");
    const groupId = ddlGroup.val();

    const element = e.sender.select();
    const item = e.sender.dataItem(element[0]) as OccupancyDay;
    const selectedDate = new Date(item.DateOfDay);

    if (groupId != null && selectedDate != null) {
        const calendarSelectedDate = $("#CSelectedDate").data("kendoCalendar");
        calendarSelectedDate.selectDates(selectedDate);

        const data = { groupId: groupId, selectedDate: selectedDate.toDateString() };
        communication.syncJSON("GET", appsettings.getUrl("Occupancy/GetOccupancy"), data, function (responseData) {
            refreshTotalsOccupancy(responseData.TotalsOccupancy);
            refreshDetailsOccupancy(responseData.DetailsOccupancy);
            addHoverFunctions();
        });
    }
}

export function onClickInformation(occupancyDateInfoText: string): void {
    main.openActionsDialog(' ', occupancyDateInfoText, [{ text: 'Ok', action: function () { main.closePopup(); } }], 180);
}
